import { render } from "./FrenteLoja.vue?vue&type=template&id=1d976e04&scoped=true"
import script from "./FrenteLoja.vue?vue&type=script&lang=js"
export * from "./FrenteLoja.vue?vue&type=script&lang=js"

import "./FrenteLoja.vue?vue&type=style&index=0&id=1d976e04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d976e04"]])

export default __exports__